    const state = () => ({
        remoteHist : null,
        afterServiceHist : null,
        reprogramHist : null,
    });
    
    const getters = {
        getRemoteHist: state => state.remoteHist,
        getAfterServiceHist: state => state.afterServiceHist,
        getReprogramHist: state => state.reprogramHist,
    };
    
    const actions = {
        setRemoteHist({ commit }, result) {
            commit('SET_REMOTEHIST', result);
        },  
        clearRemoteHist({ commit }) {
            commit('CLEAR_REMOTEHIST');
        },

        setAfterServiceHist({ commit }, result) {
            commit('SET_AFTERSERVICEHIST', result);
        },  
        clearAfterServiceHist({ commit }) {
            commit('CLEAR_AFTERSERVICEHIST');
        },

        setReprogramHist({ commit }, result) {
            commit('SET_REPROGRAMHIST', result);
        },  
        clearReprogramHist({ commit }) {
            commit('CLEAR_REPROGRAMHIST');
        },
    };
    const mutations = {
        SET_REMOTEHIST(state, result) {
            state.remoteHist = result;
        },
        CLEAR_REMOTEHIST(state) {
            state.remoteHist = null;
        },

        SET_AFTERSERVICEHIST(state, result) {
            state.afterServiceHist = result;
        },
        CLEAR_AFTERSERVICEHIST(state) {
            state.afterServiceHist = null;
        },

        SET_REPROGRAMHIST(state, result) {
            state.reprogramHist = result;
        },
        CLEAR_REPROGRAMHIST(state) {
            state.reprogramHist = null;
        },

    };
    
    export default {
      state,
      getters,
      actions,
      mutations,
    };
    